import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from '../core/core.module';
import { NewAdminRedirectComponent } from './new-admin-redirect.component';

@NgModule({
  imports: [CommonModule, CoreModule],
  exports: [NewAdminRedirectComponent],
  declarations: [NewAdminRedirectComponent]
})
export class NewAdminRedirectModule {}



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/new-admin-redirect/new-admin-redirect.module.ts